export const getUnitSystem = () => {
  const v = (typeof window !== 'undefined') ? window.localStorage.getItem('unit_system') : null;
  return v === 'metric' ? 'metric' : 'imperial';
};

export const isMetric = () => getUnitSystem() === 'metric';

export const setUnitSystem = (value) => {
  if (value !== 'imperial' && value !== 'metric') return;
  if (typeof window !== 'undefined') window.localStorage.setItem('unit_system', value);
};

